export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-plus-8f9544ac321e1358d951441c108fbaad.svg";